module.exports = __webpack_public_path__ + "media/images/products/retailers-ecommerce-7-waterstones-sample-dba5db4676bc16e4b32fe0bff51dfb83.jpg";